import { render, staticRenderFns } from "./ComponentsList.vue?vue&type=template&id=5c6411a7&scoped=true&"
import script from "./ComponentsList.vue?vue&type=script&lang=js&"
export * from "./ComponentsList.vue?vue&type=script&lang=js&"
import style0 from "./ComponentsList.vue?vue&type=style&index=0&id=5c6411a7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6411a7",
  null
  
)

export default component.exports